import {Button, Modal, Spinner, Timeline} from "flowbite-react";
import moment from "moment/moment";
import {notify} from "react-notify-toast";
import {HiArrowNarrowRight} from "react-icons/hi";
import CustomButton from "../../../components/common/CustomButton";
import React from "react";
import {useSelector} from "react-redux";

interface VersionHistoryModalProps {
  showVersionHistoryModal: boolean;
  setShowVersionHistoryModal: (showVersionHistoryModal: boolean) => void;
}

const VersionHistoryModal: React.FC<VersionHistoryModalProps> = ({ showVersionHistoryModal, setShowVersionHistoryModal }) => {
  const {
    versions,
    versionsLoading,
  } = useSelector((state: any) => state.projects);

  return (
    <Modal show={showVersionHistoryModal} onClose={() => setShowVersionHistoryModal(false)} className="h-[100vh] z-[9998]">
      <Modal.Header>Versions History</Modal.Header>
      <Modal.Body>
        <div className="space-y-6 max-h-96 overflow-auto">
          {versionsLoading ? (
              <div className="text-center w-full h-full bottom-0">
                <Spinner aria-label="Center-aligned spinner example" />
              </div>
            ) :
            <Timeline theme={{
              root: {
                direction: {
                  vertical: "relative border-l border-gray-200 dark:border-gray-600"
                }
              },
            }}>
              {versions.map((version: any) => {
                return (
                  <Timeline.Item key={version.version_project_id} className="!dark:border-gray-200">
                    <Timeline.Point theme={{
                      marker: {
                        base: {
                          vertical: " absolute left-[-6px] mt-1.5 h-3 w-3 rounded-full border border-white bg-gray-200 dark:border-gray-600 dark:bg-gray-700"
                        }
                      }
                    }} />
                    <Timeline.Content>
                      <Timeline.Title>
                        {version?.message} - {version?.version}
                      </Timeline.Title>
                      <Timeline.Time>
                        {version?.date ? `Created on ${moment(version?.date).format('LLL')}` : ""}
                      </Timeline.Time>
                      <Button className="mt-4 bg-primary-light dark:bg-primary-dark hover:bg-primary-dark text-white" onClick={() => {
                        // Handle restore click - implement if needed
                        notify.show("Restore functionality to be implemented", "success", 2000);
                      }}>
                        <p>Restore</p>
                        <HiArrowNarrowRight className="ml-2 h-3 w-3" />
                      </Button>
                    </Timeline.Content>
                  </Timeline.Item>
                )
              })}
            </Timeline>}
        </div>
      </Modal.Body>
      <Modal.Footer className="items-center flex justify-center">
        <CustomButton variant="cancel" onClick={() => setShowVersionHistoryModal(false)}>Cancel</CustomButton>
      </Modal.Footer>
    </Modal>
  )
}

export default VersionHistoryModal;